import {
  createAppSelector,
  orgUserSelectors,
  sectionUserSelectors,
  selectCurrentUserId,
  userSelectors,
} from "./base";

export const selectCurrentUser = createAppSelector(
  [selectCurrentUserId, userSelectors.selectEntities],
  (currentUserId, users) => (currentUserId ? (users[currentUserId] ?? null) : null),
);

export const selectAssessmentAIFeedbackStyle = createAppSelector(
  [selectCurrentUser],
  (currentUser) => currentUser?.assessment_ai_feedback_style ?? null,
);

/** User ids referenced by enrollment slices but not yet present in the users slice. */
export const selectMissingUserIds = createAppSelector(
  [sectionUserSelectors.selectAll, orgUserSelectors.selectAll, userSelectors.selectEntities],
  (sectionUsers, orgUsers, users) => {
    const referencedUserIds = new Set<string>();
    for (const sectionUser of sectionUsers) {
      if (sectionUser.user_id) {
        referencedUserIds.add(sectionUser.user_id);
      }
    }
    for (const orgUser of orgUsers) {
      if (orgUser.user_id) {
        referencedUserIds.add(orgUser.user_id);
      }
    }
    return [...referencedUserIds].filter((userId) => !(userId in users));
  },
);

/** Stable string for effect deps — only changes when the set of missing user ids changes. */
export const selectMissingUserIdsKey = createAppSelector([selectMissingUserIds], (missingUserIds) =>
  missingUserIds.slice().sort().join(","),
);
